import { render, staticRenderFns } from "./AppTransactionsIcon.vue?vue&type=template&id=3115e628"
import script from "./AppTransactionsIcon.vue?vue&type=script&lang=js"
export * from "./AppTransactionsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports